export async function getBase64(file) {
  return await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

export function isProducao() {
  return process.env.NODE_ENV.toLowerCase() == "production";
}

export default { getBase64, isProducao };
